import { EvaluateExpensableDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { buildEvaluatePolicyData } from '../lib/spending_policies/evaluatePolicy'

interface ExpenseData {
  expensableId?: number
  amount?: number
  currency?: string
  category?: string
  subcategory?: string | null
  effectiveOn?: string
  employeeId: number
  companyId: string
  canUseSpendingPolicies: boolean
  hasWorkflowSpendingPolicies: boolean
}

export const useSpendingPolicies = (expenseData: ExpenseData) => {
  const {
    amount,
    currency,
    category,
    effectiveOn,
    canUseSpendingPolicies,
    hasWorkflowSpendingPolicies,
  } = expenseData

  const { data, loading, refetch } = useQuery(EvaluateExpensableDocument, {
    variables: {
      amount: amount || 0,
      currency: currency || '',
      category: category || '',
      effectiveOn: effectiveOn,
      subcategory: expenseData.subcategory,
      companyId: expenseData.companyId,
      employeeId: expenseData.employeeId,
      expensableId: expenseData.expensableId,
    },
    skip:
      !amount ||
      !currency ||
      !category ||
      !effectiveOn ||
      !canUseSpendingPolicies ||
      hasWorkflowSpendingPolicies,
  })
  const policyEvaluation = data?.finance.expenseSpendingPolicyEvaluationsConnection.nodes[0]

  const policyData = buildEvaluatePolicyData(policyEvaluation)
  return { spendingPoliciesResult: policyData, loading, refetch }
}
